import { Switch, Route, Redirect } from "react-router-dom";
import LoginRoot from "../Screens/LoginRegister/LoginRoot";

export const LoginRoute = (
  <Switch>
        <Route exact path="/" render={() => <LoginRoot />} />
        <Redirect from="/signin-oidc*" to="/" />
  </Switch>
);